import type { HTMLAttributes, MouseEventHandler, ReactNode } from "react";

import { cn } from "../lib/cn";

export interface PressableProps
    extends Omit<HTMLAttributes<HTMLElement>, "children" | "onClick" | "className"> {
    children?: ReactNode;
    className?: string;
    isDisabled?: boolean;
    href?: string;
    type?: "button" | "submit" | "reset";
    onPress?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
}

export function Pressable({
    children,
    className,
    isDisabled,
    onPress,
    href,
    type = "button",
    ...props
}: PressableProps) {
    const sharedClassName = cn(
        "inline-flex cursor-pointer select-none appearance-none border-0 bg-transparent p-0 text-inherit [-webkit-tap-highlight-color:transparent]",
        "disabled:cursor-default",
        className,
    );

    if (href) {
        return (
            <a
                {...props}
                href={isDisabled ? undefined : href}
                target="_top"
                rel="noopener noreferrer"
                aria-disabled={isDisabled || undefined}
                className={cn(sharedClassName, isDisabled && "pointer-events-none")}
                onClick={onPress}
            >
                {children}
            </a>
        );
    }

    return (
        <button
            {...props}
            type={type}
            disabled={isDisabled}
            className={sharedClassName}
            onClick={onPress}
        >
            {children}
        </button>
    );
}
